"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

var Tooltip = function Tooltip(props) {
  var _positions$position;

  var componentTooltip = props.componentTooltip,
      children = props.children,
      className = props.className,
      classNameTooltip = props.classNameTooltip,
      position = props.position,
      addArrow = props.addArrow,
      transitionType = props.transitionType,
      followCursor = props.followCursor;
  var positions = {
    topStart: "top-start",
    topEnd: "top-end",
    topCenter: "top",
    rightStart: "right-start",
    rightEnd: "right-end",
    rightCenter: "right",
    bottomStart: "bottom-start",
    bottomEnd: "bottom-end",
    bottomCenter: "bottom",
    leftStart: "left-start",
    leftEnd: "left-end",
    leftCenter: "left"
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Tooltip, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    placement: (_positions$position = positions[position]) !== null && _positions$position !== void 0 ? _positions$position : positions.topCenter,
    arrow: addArrow || addArrow === undefined ? true : false,
    componentsProps: {
      tooltip: {
        className: classNameTooltip
      },
      popper: {
        disablePortal: true
      },
      transition: {
        timeout: 300
      }
    },
    TransitionComponent: transitionType === "grow" ? _material.Grow : transitionType === "fade" ? _material.Fade : _material.Zoom,
    enterDelay: 300,
    followCursor: followCursor !== null && followCursor !== void 0 ? followCursor : false,
    title: componentTooltip,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
      className: className,
      children: [" ", children, " "]
    })
  }));
};

exports.Tooltip = Tooltip;